import React, { Component } from 'react'
import './index.less'
import langM from './lang'
import { inject, observer, setUidToken, getlang, setlang, score } from 'src/helper/devTools.js'
import http from 'src/helper/http'
import localstorage from 'src/helper/localstorage'
import brower from 'src/helper/brower'
import { history } from 'src/core/router'
import { setTabBar, getDeviceInfo, jumpToWallet } from 'src/helper/webviewFun.js'
import { DatetimePicker } from 'react-vant/es/datetime-picker/index.js'
import { Picker } from 'react-vant/es/picker/index.js'
import { isRtl, convertMillisecondsToDays } from 'src/helper/tool'
import 'react-vant/es/styles'
@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.ruby = this.props.store.register('app/ruby')
  }

  state = {
    uid: 0,
    lang: langM.ar,
    language: 'en',
    setSeachValue: '',
    showEmpty: false,
    seachList: [],
    hostMemberList: [],
    guild_id: '',
    scroll: '0,20',
    selectItem: 0,
    setModalValue: 0,
    presidentDate: {},
    hostDateList: [],
    scroll: '0,10',
    hasMore: false,
    showHostDetailIndex: -1,
    inMoth: '',
    roceLv: [],
    coinLevelDolList: [],
    coinLevelGoldlList: [],
    isPresident: false,
    allroceLvList: [],
    inyear: 2024,
    inMoths: 6,
    masonryList: [],
    commissionList: [],
    allTableList: [],
    loadingMore: false,
    tableLangArr: [
      {
        title: { tr: 'Altın Maaş', ar: 'راتب  الكونزات', en: 'Gold Salary' },
        tableText: [
          { tr: 'Seviye', ar: 'مستوى', en: 'Level' },
          { tr: 'Altın Alındı', ar: 'العملات الذهبيه المحصله', en: 'Received coins' },
          { tr: 'Altın Maaş', ar: 'راتب  الكونزات', en: 'Gold salary' }
        ]
      },
      {
        title: { tr: 'AJANS SAHİBİ PRİMİ', ar: 'نسبة  الوكيل', en: 'President commission' },
        tableText: [
          { tr: 'Seviye', ar: 'مستوى', en: 'Level' },
          { tr: 'Altın Alındı', ar: 'العملات الذهبيه المحصله', en: 'Received coins' },
          { tr: 'AJANS SAHİBİ PRİMİ', ar: 'نسبة  الوكيل', en: 'President commission' }
        ]
      },
      {
        title: { tr: 'Elmas Maaş', ar: 'راتب الماس', en: 'Diamond salary' },
        tableText: [
          { tr: 'Seviye', ar: 'مستوى', en: 'Level' },
          { tr: 'Diamond', ar: 'الماس', en: 'Diamond' },
          { tr: 'Elmas Maaş', ar: 'راتب الماس', en: 'Diamond salary' }
        ]
      }
    ],
    hedinTabar: false,
    nextSettlementInterval: 0,
    settleDays: 0,
    showNotice: true,
    datePickerList: [],
    activeDatePicker: null,
    searchUid: '' // 需要查询的用户
  }

  componentDidMount() {}
  async componentWillMount() {
    console.log(this.props.location)
    let { language, searchUid } = this.props.location.query
    language = await getlang(language)
    // lang 文字对象
    // language 语言种类 (zh/ar/en/tr)
    let time = this.getNowFormatDate()
    if (localstorage.get('dataTimeDateCenter').length) {
      time = localstorage.get('dataTimeDateCenter')
      localstorage.remove('dataTimeDateCenter')
    }
    this.setState({
      lang: setlang(language, langM),
      language: language,
      // dataTime: time,
      settleDays: this.props.location.query.next_settlement_interval > 0 ? convertMillisecondsToDays(this.props.location.query.next_settlement_interval * 1000) : 0,
      nextSettlementInterval: this.props.location.query.next_settlement_interval,
      searchUid: searchUid || '' // 需要查询的用户
      // inMoth: time
    })
    const cacheNotice = window.sessionStorage.getItem('notice')
    if (cacheNotice && cacheNotice === 'false') {
      this.setState({ showNotice: false })
    }
    let uid = await setUidToken(this.props.location.query)
    await this.getGuildBillPeriod()
    this.getPresidentDate()
    await this.RunOnStart(uid)
  }

  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    // 用户id
    this.setState({
      uid: uid
    })
    let res = await getDeviceInfo()
    setTabBar('2')
    if (res.res && res.res.os && (res.res.os === 'android' || res.res.os === 'ios')) {
      let getVersionFrist = res.res.version.split('.')
      if (getVersionFrist[0] >= 4 && getVersionFrist[1] >= 0) {
        this.setState({ hedinTabar: true })
      }
    }
    this.getHostDateList()
    this.getReceiveLv()
  }

  getGuildBillPeriod = async () => {
    let { uid, searchUid } = this.state
    const res = await http.post('/web/guild/bill_period', { uid: searchUid.length > 0 ? Number(searchUid) : uid })

    if (res.code === 0) {
      let { list } = res.res
      this.setState({
        datePickerList: list || 0,
        activeDatePicker: list[0] || '',
        dataTime: list[0] || ''
      })
    }
  }

  // 设置当前月
  setInMoth = (serverTime) => {
    let time = null
    if (serverTime) {
      time = this.getNowFormatDate(serverTime)
    }

    this.setState({
      inMoth: time
    })
  }

  getMemberList = async (id) => {
    let { scroll, guild_id, hostMemberList, setSeachValue } = this.state
    let res = await http.post('/web/guild/member', {
      scroll: '0',
      guild_id: id || guild_id,
      kw: setSeachValue
    })
    if (res.code == 0) {
      this.setState({
        scroll: res.res.scroll,
        hahasMore: res.res.hahasMore,
        hostMemberList: [...res.res.list]
      })
    }
  }

  clsoeModal = (e) => {
    // 4 分成  2 金币 5 砖石薪资
    this.setState({ setModalValue: e })
  }

  selectSider = (e, index) => {
    e.stopPropagation()
    this.setState({ selectItem: index })
  }

  getPresidentDate = async () => {
    let { dataTime: month, uid, searchUid } = this.state
    let res = await http.post('/web/guild/salary_info', {
      month: month,
      uid: searchUid.length > 0 ? Number(searchUid) : uid
    })
    if (res.code == 0) {
      this.setInMoth(res.res.ts)
      // console.log(5555555555555,res)
      this.setState({
        presidentDate: {
          ...res.res,
          coin_salary: res.res.coin_salary / 100,
          diamond_salary: res.res.diamond_salary / 100,
          commission: res.res.commission / 100,
          empty_diamond: res.res.empty_diamond / 100,
          coin: res.res.coin / 100,
          diamond: res.res.diamond / 100,
          GuildSalary: res.res.GuildSalary / 100,
          MemberTotal: res.res.MemberTotal / 100,
          Commission: res.res.Commission / 100,
          CommissionTotal: res.res.CommissionTotal / 100,
          status: res.res.status,
        },
        isPresident: res.res.IsPresident == 1 ? true : false
      })
    }
  }

  getReceiveLv = async () => {
    let { uid, searchUid } = this.state
    let res = await http.post('/web/guild/salary_setting', {
      uid: searchUid.length > 0 ? Number(searchUid) : uid
    })
    if (res.code == 0) {
      let arr = []
      let coinLevelDolList = []
      let coinLevelGoldlList = []
      for (let index = 0; index < res.res[1].length; index + 3) {
        arr.push(res.res[1].slice(index, (index += 3)))
      }
      ;[...res.res[1]].forEach((item) => {
        if (item[1] > item[0]) {
          coinLevelGoldlList.push(item[1])
        } else {
          coinLevelGoldlList.push(item[0])
        }
        if (item[1] < item[0]) {
          coinLevelDolList.push(item[1] / 100)
        } else {
          coinLevelDolList.push(item[0] / 100)
        }
      })

      this.setState({
        roceLv: arr,
        roceLvlength: res.res[1].length,
        coinLevelGoldlList,
        coinLevelDolList,
        allroceLvList: res.res[1],
        commissionList: res.res[3],
        masonryList: res.res[2],
        allTableList: [res.res[1], res.res[3], res.res[2]]
      })
    }
  }

  //获取当前日期函数
  getNowFormatDate = (time) => {
    let date = time ? new Date(time * 1000) : new Date(),
      year = date.getFullYear(), //获取完整的年份(4位)
      month = date.getMonth() + 1 //获取当前月份(0-11,0代表1月)
    if (month < 10) month = `0${month}` // 如果月份是个位数，在前面补0
    this.setState({ inMoths: month, inyear: year })
    return `${year}-${month}`
  }

  monthpicker = async (date) => {
    console.log(date)
    await this.setState({
      dataTime: date,
      activeDatePicker: date,
      setModalValue: 0
    })
    this.getHostDateList(date)
    this.getPresidentDate()
  }

  getTextdol = (e) => {
    return e ? `$ ${e}` : 0
  }

  goToShowMicInfo = (userId) => {
    if (userId == 0) {
      console.log('uid 0 error')
      return
    }
    let { language, dataTime } = this.state
    localstorage.set('dataTimeDateCenter', dataTime)
    history.push(`app/livetimeMic?uid=${userId}&searchUid=${userId}&month=${dataTime}&language=${language}`)
  }

  getHostDateList = async () => {
    let { dataTime, uid, searchUid } = this.state
    let res = await http.post('/web/guild/member_salary_list', {
      month: dataTime,
      scrol: '',
      uid: searchUid.length > 0 ? Number(searchUid) : uid
    })
    if (res.code === 0) {
      this.setState({
        hostDateList: res.res.list ? res.res.list : [],
        scroll: res.res.scroll,
        hasMore: res.res.has_more
      })
    }
  }

  showWhatHostDetail = (index) => {
    let { showHostDetailIndex } = this.state
    this.setState({ showHostDetailIndex: showHostDetailIndex == index ? -1 : index })
  }

  addRankingList = async () => {
    let { scroll, hostDateList, dataTime } = this.state
    if (this.state.loadingMore == true) {
      return
    }
    this.setState({
      loadingMore: true
    })
    let res = await http.post('/web/guild/member_salary_list', { scroll, month: dataTime })
    if (res.code == 0) {
      if (res.res.list.length > 0) {
        this.setState({
          hostDateList: res.res.list.length && [...hostDateList, ...res.res.list],
          scroll: res.res.scroll,
          hasMore: res.res.has_more,
          loadingMore: false
        })
      } else {
        this.setState({
          // hostDateList: res.res.list.length && [...hostDateList, ...res.res.list],
          scroll: res.res.scroll,
          hasMore: false,
          loadingMore: false
        })
      }
    } else {
      this.setState({
        loadingMore: false
      })
    }
  }

  handleScroll = (e) => {
    const { scrollTop, clientHeight, scrollHeight } = e.target
    let { hasMore, isPresident } = this.state
    if (scrollTop + clientHeight + 50 >= scrollHeight) {
      if (hasMore && isPresident) return this.addRankingList()
    }
  }

  setDomStyle = (e, obj) => {
    let { dataTime, inMoth, presidentDate } = this.state
    let ojb = obj || presidentDate
    let nums = 0
    e.forEach((item) => {
      nums += ojb[item]
    })
    if (dataTime == inMoth) {
      nums - presidentDate.diamond_salary
    }
    return nums.toString().length >= 9 ? { fontSize: '0.32rem' } : { fontSize: '0.4rem' }
  }

  getPDValue(movKey, wantZro) {
    let { presidentDate: e } = this.state
    if (!wantZro) {
      return e[movKey] ? e[movKey] : '0'
    } else if (wantZro == 1) {
      return e[movKey] ? (e[movKey] / 60).toFixed(1) : '0'
    }
  }

  getGoldRatio = () => {
    let { presidentDate, coinLevelGoldlList } = this.state
    return `${presidentDate.coin || 0}/${
      coinLevelGoldlList[
        presidentDate.CoinLevel >= coinLevelGoldlList.length ? coinLevelGoldlList.length - 1 : presidentDate.CoinLevel
      ] / 100 || 0
    }`
  }

  getLeveInDoller = () => {
    let { presidentDate, coinLevelDolList } = this.state
    return `LV${presidentDate.CoinLevel - 1 >= 0 ? presidentDate.CoinLevel : 0}($${
      presidentDate.CoinLevel > 0 ? coinLevelDolList[presidentDate.CoinLevel - 1] : 0
    })`
  }

  cbFn = async () => {
    await localstorage.set('cb', 1)
    history.goBack()
  }

  onCloseNotice = () => {
    this.setState({ showNotice: false })
    window.sessionStorage.setItem('notice', 'false')
  }

  goWallet = () => {
    const page = brower.isIphone() ? 1 : 2
    jumpToWallet(page)
  }

  render() {
    let {
      uid,
      lang,
      language,
      inyear,
      inMoths,
      allroceLvList,
      isPresident,
      roceLvlength,
      coinLevelList,
      allTableList,
      tableLangArr,
      inMoth,
      hostDateList,
      showHostDetailIndex,
      roceLv,
      presidentDate,
      setModalValue,
      selectItem,
      dataTime,
      coinLevelGoldlList,
      hedinTabar,
      nextSettlementInterval,
      settleDays,
      showNotice,
      datePickerList,
      activeDatePicker,
      searchUid
    } = this.state
    return (
      <div className={`datacenter  ${isRtl(language) && 'arlang'}`}>
        {/* <div className="" style={{ height: `${hedinTabar ? '0.88rem' : '0.44rem'}` }}></div> */}
        <div className="" style={{ height: `0.44rem` }}></div>
        <div className="nav-top-root">
          {<div style={{ width: '100%', height: '0.44rem' }}></div>}
          <div className="nav-top">
            <img
              className="close-view"
              src="img/app/newhost/colse_cb.png"
              style={{ transform: `${isRtl(language) ? 'rotate(180deg)' : ''}` }}
              onClick={() => this.cbFn()}
            ></img>
            <div className="title-name">{lang.domTitle}</div>
          </div>
        </div>
        {
          nextSettlementInterval > 0 && showNotice && (
            <div className='notice-wrap'>
              <p onClick={() => this.goWallet()}>
                {/* { settleDays > 1 ? lang.notice.replace('{{n}}', settleDays) : lang.notice2} */}
                { lang.notice3 }
              </p>
              <div className={'icon-wrap'} onClick={this.onCloseNotice}>
                {/* <CloseOutline fontSize={'0.32rem'} /> */}
                <img className="open-icon" src="img/app/newhost/close.png" />
              </div>
            </div>
          )
        }
        <div className="time-com-root">
          <div className="time-text">{lang.timeText}</div>
          <div className="open-time-root" onClick={() => this.clsoeModal(8)}>
            <img className="time-icon" src="img/app/newhost/time_left_icon_opne.png" />
            <div className="tiem-num">{dataTime}</div>
            <img className="open-icon" src="img/app/newhost/time_open_icon.png" />
          </div>
        </div>
        {isPresident == 1 && (
          <div>
            <div className="union-data">
              <div className="data-title">
                <img src="/img/app/newhost/tradeUnion_data.png" className="data-infomun" />
                <div className="data-text">{lang.dataDetails}</div>
              </div>
              <div className="inlive-time" onClick={() => this.goToShowMicInfo(searchUid || uid)}>
                <div className="live-time-total">
                  <div className="title">{lang.totallivetime}</div>
                  <div className="num">{`${this.getPDValue('on_mic_times', 1)}h`}</div>
                </div>
                <div className="line-in"></div>
                <div className="hour">
                  <div className="title">{lang.bigTwoTime}</div>
                  <div className="num">{`${this.getPDValue('active_days')}${lang.days}`}</div>
                </div>
                <img
                  className="sb-cp"
                  style={{
                    [isRtl(language) ? 'left' : 'right']: '0.16rem',
                    transform: `${isRtl(language) ? 'rotate(90deg)' : 'rotate(-90deg)'}`
                  }}
                  src="img/app/newhost/time_open_icon.png"
                  onClick={() => this.goToShowMicInfo(searchUid || uid)}
                />
              </div>
              <div className="numerical-statistics">
                <div className="statistics-item">
                  <div className="num">{this.getTextdol(presidentDate.GuildSalary)}</div>
                  <div className="tip">{lang.agencysalary}</div>
                </div>
                <div className="statistics-item">
                  <div className="num" style={this.setDomStyle(['CommissionTotal', 'coin_salary', 'diamond_salary'])}>
                    {this.getTextdol(
                      presidentDate.CommissionTotal +
                        presidentDate.coin_salary +
                        (dataTime !== inMoth ? presidentDate.diamond_salary : 0)
                    )}
                  </div>
                  <div className="tip">{lang.presidentsalary}</div>
                </div>
                <div className="statistics-item">
                  <div className="num" style={this.setDomStyle(['MemberTotal'])}>
                    {this.getTextdol(presidentDate.MemberTotal)}
                  </div>
                  <div className="tip">{lang.otherhostsalary}</div>
                </div>
                <div className="statistics-item">
                  <div className="num" style={this.setDomStyle(['CommissionTotal'])}>
                    {this.getTextdol(presidentDate.CommissionTotal)}
                  </div>
                  <div className="tip">{lang.Presidentcommission}</div>
                  <img className="doubt-root" onClick={() => this.clsoeModal(3)} src="img/app/newhost/doubt.png" />
                </div>
                <div className="statistics-item">
                  <div className="num" style={this.setDomStyle(['coin_salary'])}>
                    {this.getTextdol(presidentDate.coin_salary)}
                  </div>
                  <div className="tip">{lang.Goldsalary}</div>
                  <img className="doubt-root" onClick={() => this.clsoeModal(2)} src="img/app/newhost/doubt.png" />
                </div>
                <div className="statistics-item">
                  <div className="num" style={this.setDomStyle(['diamond_salary'])}>
                    {presidentDate.status === 2 ? this.getTextdol(presidentDate.diamond_salary) : '一'}
                  </div>
                  <div className="tip">{lang.Diamondsalary}</div>
                  <img className="doubt-root" src="img/app/newhost/doubt.png" onClick={() => this.clsoeModal(4)} />
                </div>
              </div>
              <div className="numerical-statistics">
                <div className="statistics-item">
                  <div className="num">{this.getTextdol(presidentDate.withdrawal_salary / 100)}</div>
                  <div className="tip">{lang.withdrawnSalary}</div>
                </div>
              </div>
            </div>
            <div className="receives-gift-streams">
              <div className="in-the-top" onClick={() => this.goToShowMicInfo(searchUid || uid)}>
                <div className="in-the-top-left">
                  <img src="img/app/newhost/host_data_icon.png" className="db-icon" />
                  <div className="title">{lang.Receivedcoins}</div>
                </div>
                <img
                  style={{ width: '0.4rem', height: '0.4rem' }}
                  src="img/app/newhost/to_mic.png"
                  onClick={() => this.goToShowMicInfo(searchUid || uid)}
                />
              </div>
              <div className="in-lv-hahw">
                <div className="left">
                  <div className="lv-num">{this.getLeveInDoller()}</div>
                  <img src="img/app/newhost/gift_icon.png" className="gift-icon" />
                </div>
                <div className="right">
                  <img src="img/app/newhost/glod_icon.png" className="gold_img-root" />
                  <div className="lv-num-info">{this.getGoldRatio()}</div>
                  <img
                    style={{
                      margin: '0 0.08rem',
                      transform: `${isRtl(language) ? 'rotate(90deg)' : 'rotate(-90deg)'}`,
                      width: '0.32rem',
                      height: '0.32rem'
                    }}
                    src="img/app/newhost/time_open_icon.png"
                    onClick={(e) => this.clsoeModal(1)}
                  />
                </div>
              </div>
              <div className="slider">
                <div
                  className="inset-root"
                  style={{
                    width: `${(
                      ((presidentDate.coin * 100) /
                        coinLevelGoldlList[
                          presidentDate.CoinLevel >= coinLevelGoldlList.length
                            ? coinLevelGoldlList.length - 1
                            : presidentDate.CoinLevel
                        ]) *
                      6.38
                    ).toFixed(2)}rem`
                  }}
                ></div>
              </div>
              <div className="diamond-clear">
                <div className="diamond">
                  <div className="tip">{lang.diamondsalarylevel}</div>
                  <div className="num">
                    <div className="no-value">{dataTime === inMoth ? '一' : `Lv ${presidentDate.DiamondLevel}`}</div>
                    <div className="text-num"></div>
                  </div>
                </div>
                <div className="clear">
                  <div className="tip">{lang.Cleardiamondcount}</div>
                  <div className="num">
                    <img className="icon" src="img/app/newhost/gold_ruby_weite.png" />
                    <div className="no-value">{dataTime === inMoth ? '一' : score(presidentDate.empty_diamond)}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {isPresident == 0 && (
          <div>
            <div className="union-data">
              <div className="data-title">
                <img src="/img/app/newhost/host_date_icon.png" className="data-infomun" />
                <div className="data-text">{lang.dataDetails}</div>
              </div>
              <div className="inlive-time" onClick={() => this.goToShowMicInfo(searchUid || uid)}>
                <div className="live-time-total">
                  <div className="title">{lang.totallivetime}</div>
                  <div className="num">{`${
                    presidentDate.on_mic_times ? (presidentDate.on_mic_times / 60).toFixed(1) : 0
                  }h`}</div>
                </div>
                <div className="line-in"></div>
                <div className="hour">
                  <div className="title">{lang.bigTwoTime}</div>
                  <div className="num">{`${presidentDate.active_days || '0'}${lang.days}`}</div>
                  <img
                    className="arrow-right"
                    style={{
                      transform: `${isRtl(language) ? 'rotate(90deg)' : 'rotate(-90deg)'}`,
                      [language !== 'ar' ? 'right' : 'left']: '0.16rem'
                    }}
                    src="img/app/newhost/time_open_icon.png"
                  />
                </div>
              </div>
              <div className="numerical-statistics">
                <div className="statistics-item">
                  <div className="num" style={this.setDomStyle(['coin_salary', 'diamond_salary'])}>
                    {this.getTextdol(presidentDate.coin_salary + presidentDate.diamond_salary)}
                  </div>
                  <div className="tip">{lang.TotalSalary}</div>
                </div>
                <div className="statistics-item">
                  <div className="num" style={this.setDomStyle(['coin_salary'])}>
                    {this.getTextdol(presidentDate.coin_salary)}
                  </div>
                  <div className="tip">{lang.Goldsalary}</div>
                  <img className="doubt-root" onClick={() => this.clsoeModal(2)} src="img/app/newhost/g_boubt.png" />
                </div>
                <div className="statistics-item">
                  <div className="num" style={this.setDomStyle(['diamond_salary'])}>
                    {dataTime == inMoth ? '一' : this.getTextdol(presidentDate.diamond_salary)}
                  </div>
                  <div className="tip">{lang.Diamondsalary}</div>
                  <img className="doubt-root" src="img/app/newhost/g_boubt.png" onClick={() => this.clsoeModal(4)} />
                </div>
              </div>
              <div className="numerical-statistics">
                <div className="statistics-item">
                  <div className="num">{this.getTextdol(presidentDate.withdrawal_salary / 100)}</div>
                  <div className="tip">{lang.withdrawnSalary}</div>
                </div>
              </div>
            </div>
            {dataTime !== inMoth && (
              <div className="showHost-lastMoth">
                <div className="showHost-lastMoth-item">
                  <div className="top-text-iooe">Lv{presidentDate.CoinLevel}</div>
                  <div className="bm-text-iooe">{lang.Coinssalarylevel}</div>
                </div>
                <div className="showHost-lastMoth-item">
                  <div className="top-text-iooe">{presidentDate.coin}</div>
                  <div className="bm-text-iooe">{lang.Receivedcoins}</div>
                </div>
                <div className="showHost-lastMoth-item">
                  <div className="top-text-iooe">Lv{presidentDate.DiamondLevel}</div>
                  <div className="bm-text-iooe">{lang.diamondsalarylevel}</div>
                </div>
                <div className="showHost-lastMoth-item">
                  <div className="top-text-iooe">{presidentDate.empty_diamond}</div>
                  <div className="bm-text-iooe">{lang.Cleardiamondcount}</div>
                </div>
              </div>
            )}
            {dataTime == inMoth && (
              <div className="receives-gift-streams">
                <div className="in-the-top" onClick={() => this.goToShowMicInfo(searchUid || uid)}>
                  <div className="in-the-top-left">
                    <img src="img/app/newhost/host_data_icon.png" className="db-icon" />
                    <div className="title">{lang.Receivedcoins}</div>
                  </div>
                  <img
                    style={{
                      width: '0.4rem',
                      height: '0.4rem',
                      transform: `${isRtl(language) ? 'rotate(90deg)' : ''}`
                    }}
                    src="img/app/newhost/to_mic.png"
                    onClick={() => this.goToShowMicInfo(searchUid || uid)}
                  />
                </div>
                <div className="in-lv-hahw">
                  <div className="left">
                    <div className="lv-num">{this.getLeveInDoller()}</div>
                    <img src="img/app/newhost/gift_icon.png" className="gift-icon" />
                  </div>
                  <div className="right">
                    <img src="img/app/newhost/glod_icon.png" className="gold_img-root" />
                    <div className="lv-num-info">{this.getGoldRatio()}</div>
                    <img
                      style={{
                        margin: '0 0.08rem',
                        transform: `${isRtl(language) ? 'rotate(90deg)' : 'rotate(-90deg)'}`,
                        width: '0.32rem',
                        height: '0.32rem'
                      }}
                      src="img/app/newhost/time_open_icon.png"
                      onClick={(e) => this.clsoeModal(1)}
                    />
                  </div>
                </div>
                <div className="slider">
                  <div
                    className="inset-root"
                    style={{
                      width: `${(
                        ((presidentDate.coin * 100) /
                          coinLevelGoldlList[
                            presidentDate.CoinLevel >= coinLevelGoldlList.length
                              ? coinLevelGoldlList.length - 1
                              : presidentDate.CoinLevel
                          ]) *
                        6.38
                      ).toFixed(2)}rem`
                    }}
                  ></div>
                </div>
                <div className="diamond-clear">
                  <div className="diamond">
                    <div className="tip">{lang.diamondsalarylevel}</div>
                    <div className="num">
                      <div className="no-value">{dataTime == inMoth ? '一' : `Lv ${presidentDate.DiamondLevel}`}</div>
                      <div className="text-num"></div>
                    </div>
                  </div>
                  <div className="clear">
                    <div className="tip">{lang.Cleardiamondcount}</div>
                    <div className="num">
                      <img className="icon" src="img/app/newhost/gold_ruby_weite.png" />
                      <div className="no-value">{dataTime == inMoth ? '一' : score(presidentDate.empty_diamond)}</div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        {isPresident && hostDateList.length > 0 && (
          <div
            className="host-details"
            onScroll={(e) => {
              this.handleScroll(e)
            }}
          >
            <div className="title-text">
              <img className="title-img" src="img/app/newhost/host_date_icon.png"></img>
              <div className="title-text">{lang.hostdetails}</div>
            </div>
            {hostDateList.length > 0 &&
              hostDateList.map((item, index) => (
                <div className="item-details" key={index}>
                  <div className="host-user-info">
                    <div className="host-user-info-left">
                      <div className="num">{index + 1}</div>
                      <img className="host-user-atv" src={item.avatar_url || ''}></img>
                      <div className="host-info-name">
                        <div className="name">{item.nickname || ''}</div>
                        <div className="id-duid">ID : {item.duid || ''}</div>
                      </div>
                    </div>
                    <div className="host-user-info-right">
                      <img className="gold-icon-host" src="img/app/newhost/glod_icon.png"></img>
                      <div className="gold-num">{score(item.salary_info.coin / 100)}</div>
                      <img
                        className={`open-icon ${showHostDetailIndex == index ? 'turn' : ''}`}
                        src="img/app/newhost/time_open_icon.png"
                        onClick={(e) => {
                          e.stopPropagation()
                          this.showWhatHostDetail(index)
                        }}
                      />
                    </div>
                  </div>
                  {showHostDetailIndex == index && (
                    <div className={`show-or-heddin ${showHostDetailIndex == index ? '' : ''}`}>
                      <div className="host-getnum">
                        <div className="show-one">
                          <div
                            className="num"
                            style={this.setDomStyle(['diamond_salary', 'coin_salary'], item.salary_info)}
                          >{`$${(item.salary_info.diamond_salary + item.salary_info.coin_salary) / 100}`}</div>
                          <div className="tip">{lang.TotalSalary}</div>
                        </div>
                        <div className="line"></div>
                        <div className="show-one">
                          <div className="num" style={this.setDomStyle(['coin_salary'], item.salary_info)}>{`$${
                            item.salary_info.coin_salary / 100
                          }`}</div>
                          <div className="tip">{lang.Goldsalary}</div>
                          <img
                            className="doutb-icon"
                            src="img/app/newhost/g_boubt.png"
                            onClick={() => this.clsoeModal(2)}
                          />
                        </div>
                        <div className="line"></div>
                        <div className="show-one">
                          <div className="num" style={this.setDomStyle(['diamond_salary'], item.salary_info)}>
                            {dataTime == inMoth ? '一' : `$ ${item.salary_info.diamond_salary / 100}`}
                          </div>
                          <div className="tip">{lang.Diamondsalary}</div>
                          <img
                            className="doutb-icon"
                            src="img/app/newhost/g_boubt.png"
                            onClick={() => this.clsoeModal(4)}
                          />
                        </div>
                      </div>
                      <div className="host-inlv">
                        <div className="host-inlv-item">
                          <div className="num-text">{`LV.${item.salary_info.CoinLevel}`}</div>
                          <div className="tip-text">{lang.Coinssalarylevel}</div>
                        </div>
                        <div className="host-inlv-item">
                          <div className="num-text">{score(item.salary_info.coin / 100)}</div>
                          <div className="tip-text">{lang.Receivedcoins}</div>
                          <img
                            className="doutb-icon"
                            src="img/app/newhost/g_boubt.png"
                            onClick={() => this.clsoeModal(2)}
                          />
                        </div>
                        <div className="host-inlv-item">
                          <div className="num-text" style={this.setDomStyle(['commission'], item.salary_info)}>
                            ${item.salary_info.commission / 100}
                          </div>
                          <div className="tip-text">{lang.Presidentcommission}</div>
                          <img
                            className="doutb-icon"
                            src="img/app/newhost/g_boubt.png"
                            onClick={() => this.clsoeModal(3)}
                          />
                        </div>
                      </div>
                      <div className="host-diamond-clear">
                        <div className="diamond">
                          <div className="tip">{lang.diamondsalarylevel}</div>
                          <div className="num">
                            <div className="no-value">
                              {dataTime === inMoth ? '一' : `Lv. ${item.salary_info.DiamondLevel}`}
                            </div>
                            <div className="text-num"></div>
                          </div>
                        </div>
                        <div className="clear">
                          <div className="tip">{lang.Cleardiamondcount}</div>
                          <div className="num">
                            <img className="icon" src="img/app/newhost/gold_ruby_weite.png" />
                            <div className="no-value">
                              {dataTime === inMoth ? '一' : score(item.salary_info.empty_diamond / 100)}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="line-let-let"></div>
                    </div>
                  )}
                  <div className="inmic-time" onClick={() => this.goToShowMicInfo(item.uid)}>
                    <div className="left">
                      {lang.totallivetime}:{' '}
                      {item.salary_info.on_mic_times > 0 ? (item.salary_info.on_mic_times / 60).toFixed(1) : 0}
                    </div>
                    <div className="f-line"></div>
                    <div className="right">
                      <div className="text">{`${lang.bigTwoTime}: ${item.salary_info.active_days} ${lang.days}`}</div>
                      <img
                        className="arrow"
                        src="img/app/newhost/host_detials_icon_arwor.png"
                        style={{ transform: `${isRtl(language) ? 'rotate(180deg)' : ''}` }}
                      />
                    </div>
                  </div>
                </div>
              ))}
          </div>
        )}
        {setModalValue > 0 && (
          <div
            className="show-modal"
            onClick={(e) => {
              e.stopPropagation()
              this.clsoeModal(0)
            }}
          >
            {setModalValue == 1 && (
              <div
                className="show-receive"
                onClick={(e) => {
                  e.stopPropagation()
                }}
              >
                <div className="title-inshow">{lang.Receivedcoins}</div>
                <div className="lv-sider-root">
                  <div className="lv-sider-item">
                    {roceLv.length > 0 &&
                      roceLv.map((item, index) => (
                        <div
                          style={{ marginRight: `${isRtl(language) ? '0' : '0.5rem'}` }}
                          className={`item-lv-num ${index == selectItem ? 'inselect' : ''}`}
                          onClick={(e) => this.selectSider(e, index)}
                          key={index}
                        >{`lv ${index * 3 + 1}${
                          index * 3 + 3 > roceLvlength ? `～${roceLvlength}` : `～${index * 3 + 3}`
                        }`}</div>
                      ))}
                  </div>
                </div>
                {roceLv.length > 0 &&
                  roceLv[selectItem].map((item, index) => (
                    <div className="showSelect-item" key={index}>
                      <div className="lv-info">
                        <div className="lv-info-left">{`Lv ${selectItem * 3 + index}～${selectItem * 3 + index + 1}（$${
                          item[1] / 100
                        }）`}</div>
                        <div className="lv-info-right">
                          <img className="gold-showmodal" src="img/app/newhost/glod_icon.png" />
                          <div className="where-num">{`${presidentDate.coin || 0}/${item[0] / 100}`}</div>
                        </div>
                      </div>
                      <div className="lv-sider">
                        <div className="empty-rootinyse" style={{ backgroundColor: '#FDE0DF' }}></div>
                        <div
                          className="set-inmov"
                          style={{ width: `${(presidentDate.coin * 5.48) / (item[0] / 100)}rem` }}
                        ></div>
                      </div>
                    </div>
                  ))}
              </div>
            )}
            {setModalValue >= 2 && setModalValue <= 4 && (
              <div
                className="gold-coins-salary"
                onClick={(e) => {
                  e.stopPropagation()
                }}
              >
                <div className="text-gold-coins-salary">{tableLangArr[setModalValue - 2].title[language]}</div>
                <div className="table-root-indatrcenter">
                  <div className="rwb-table">
                    <table>
                      <thead>
                        <tr>
                          <td>{tableLangArr[setModalValue - 2].tableText[0][language]}</td>
                          <td>{tableLangArr[setModalValue - 2].tableText[1][language]}</td>
                          <td>{tableLangArr[setModalValue - 2].tableText[2][language]}</td>
                        </tr>
                      </thead>

                      {allTableList[setModalValue - 2].length > 0 &&
                        allTableList[setModalValue - 2].map((item, index) => {
                          return (
                            <tbody key={index}>
                              <tr>
                                <td style={{ backgroundColor: '#dbeaff' }}>{index + 1}</td>
                                <td style={{ backgroundColor: '#ebf1fd' }}>{item[0] / 100}</td>
                                <td style={{ backgroundColor: '#c4edb3' }}>{item[1] / 100}</td>
                              </tr>
                            </tbody>
                          )
                        })}
                    </table>
                  </div>
                </div>
              </div>
            )}
            {setModalValue == 8 && (
              <div
                className="time-selectpick"
                onClick={(e) => {
                  e.stopPropagation()
                }}
              >
                <Picker
                  columns={datePickerList}
                  itemHeight={'0.88rem'}
                  defaultValue={activeDatePicker}
                  placeholder={''}
                  confirmButtonText={lang.confirm}
                  cancelButtonText={lang.cancel}
                  onCancel={() => this.clsoeModal(0)}
                  onConfirm={this.monthpicker}
                />
                {/* <DatetimePicker
                  type="year-month"
                  minDate={new Date(2024, 3)}
                  maxDate={new Date(inyear, inMoths - 1)}
                  value={dataTime}
                  itemHeight={'0.88rem'}
                  onConfirm={this.monthpicker}
                  confirmButtonText={lang.confirm}
                  cancelButtonText={lang.cancel}
                  onCancel={() => this.clsoeModal(0)}
                /> */}
              </div>
            )}
          </div>
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// src/pages/app/datacenter/index.js